import React, { useMemo, useState } from "react";
import { Pressable, Text, View } from "react-native";
import { useAIExhibitFixedNarration } from "../audio/useAIExhibitFixedNarration";
import { AI_EXHIBIT_COLORS as C } from "../aiExhibitTheme";

const NARRATION_BY_CAPABILITY_ID = Object.freeze({
  reasoning: "ai_today_reasoning",
  agents: "ai_today_agents",
  robots: "ai_today_robots",
});
import { getAIExhibitCurrentStatus } from "../content/aiExhibitCurrentStatus";
import { getAIExhibitBatch4Copy } from "../content/aiExhibitBatch4Content";

export default function AITodayScreen({
  navigate,
  language = "en",
  audioEnabled = false,
}) {
  const { playNarration } = useAIExhibitFixedNarration({
    audioEnabled,
    language,
  });
  const t = getAIExhibitBatch4Copy(language).today;
  const current = getAIExhibitCurrentStatus(language);
  const items = current.capabilityCards;
  const [selectedId, setSelectedId] = useState(items[0].id);
  const item = useMemo(() => items.find((x) => x.id === selectedId) || items[0], [selectedId, items]);

  return <View style={{ padding: 28 }}>
    <Text style={{ color:C.accent,fontSize:13,fontWeight:"900",letterSpacing:1.2 }}>{t.eyebrow}</Text>
    <Text style={{ color:C.text,fontSize:44,lineHeight:50,fontWeight:"900",marginTop:8 }}>{t.title}</Text>
    <Text style={{ color:C.muted,fontSize:18,lineHeight:27,marginTop:8,maxWidth:980 }}>{t.subtitle}</Text>
    <View style={{marginTop:16,alignSelf:"flex-start",paddingHorizontal:12,paddingVertical:8,borderRadius:999,backgroundColor:C.accentSoft}}>
      <Text style={{color:C.accent,fontSize:13,fontWeight:"900"}}>{t.updated}: {current.lastReviewed}</Text>
    </View>

    <View style={{flexDirection:"row",flexWrap:"wrap",gap:14,marginTop:22}}>
      {items.map((x)=>{const active=x.id===selectedId;return <Pressable key={x.id} onPress={()=>{
        setSelectedId(x.id);
        playNarration(NARRATION_BY_CAPABILITY_ID[x.id]);
      }} style={({pressed})=>({flex:1,minWidth:270,minHeight:185,padding:20,borderRadius:18,borderWidth:active?2:1,borderColor:active?C.accent:C.border,backgroundColor:active||pressed?C.accentSoft:C.surfaceRaised})}>
        <Text style={{fontSize:31}}>{x.icon}</Text>
        <Text style={{color:C.muted,fontSize:12,fontWeight:"900",marginTop:10}}>{x.shortLabel.toUpperCase()}</Text>
        <Text style={{color:C.text,fontSize:22,lineHeight:28,fontWeight:"900",marginTop:6}}>{x.headline}</Text>
        <Text style={{color:C.accent,fontSize:30,fontWeight:"900",marginTop:8}}>{x.metric}</Text>
        <Text style={{color:C.muted,fontSize:13,lineHeight:19,marginTop:3}}>{x.metricLabel}</Text>
      </Pressable>})}
    </View>

    <View style={{marginTop:18,padding:22,borderRadius:18,borderWidth:1,borderColor:C.border,backgroundColor:C.surfaceRaised}}>
      <Text style={{color:C.accent,fontSize:13,fontWeight:"900"}}>{t.whatMeans.toUpperCase()}</Text>
      <Text style={{color:C.text,fontSize:18,lineHeight:28,marginTop:8}}>{item.detail}</Text>
      <View style={{marginTop:14,padding:15,borderRadius:14,borderLeftWidth:5,borderWidth:1,borderColor:C.border,borderLeftColor:C.warning,backgroundColor:C.surface}}>
        <Text style={{color:C.warning,fontSize:12,fontWeight:"900"}}>{t.caution.toUpperCase()}</Text>
        <Text style={{color:C.text,fontSize:15,lineHeight:23,marginTop:6}}>{item.caution}</Text>
      </View>
      <Text style={{color:C.muted,fontSize:12,marginTop:12}}>{item.sourceLabel}</Text>
    </View>

    <View style={{marginTop:16,padding:15,borderRadius:14,borderWidth:1,borderColor:C.border,backgroundColor:C.accentSoft}}><Text style={{color:C.text,fontSize:15,lineHeight:23}}>{t.updateRule}</Text></View>

    <View style={{flexDirection:"row",flexWrap:"wrap",gap:12,marginTop:20}}>
      <Pressable onPress={()=>navigate("jagged_frontier")} style={({pressed})=>({minHeight:58,paddingHorizontal:22,paddingVertical:14,borderRadius:16,borderWidth:1,borderColor:C.accent,backgroundColor:pressed?C.surfaceRaised:C.accentSoft})}><Text style={{color:C.text,fontSize:17,fontWeight:"900"}}>{t.nextJagged} →</Text></Pressable>
      <Pressable onPress={()=>navigate("humans_ai")} style={({pressed})=>({minHeight:58,paddingHorizontal:22,paddingVertical:14,borderRadius:16,borderWidth:1,borderColor:C.border,backgroundColor:pressed?C.accentSoft:C.surfaceRaised})}><Text style={{color:C.text,fontSize:17,fontWeight:"900"}}>{t.nextHumans} →</Text></Pressable>
    </View>
  </View>;
}
